
import { defineComponent } from "vue";
import BannerForeground from "@/assets/ci22-convid19-fg.png";

export default defineComponent({
  setup() {
    return {
      BannerForeground,
    };
  },
});
